// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class UrlUtils {
    static ParseTextForURL(text, allowShortURL) {
        // при allowShortURL = true строки вида google.com или www.google.com также считаются URL
        const arr = text.split(UrlUtils.urlRegex);
        const result = [];
        for (const element of arr) {
            const it = element;
            const isUrl = allowShortURL ? UrlUtils.isUrl(it) : !!new RegExp(UrlUtils.urlRegex).exec(it);
            result.push({ isText: !isUrl, value: it });
        }
        return result;
    }
    static isUrl(str) {
        if (!isValidString(str)) {
            return false;
        }
        const s = str.trim();
        if (s.length === 0 || s.length > 2048) {
            return false;
        }
        const pattern = new RegExp(String.raw `^` +
            String.raw `(?:https?:\/\/)?` +
            String.raw `(?:` +
            String.raw `(?:[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?\.)+[a-z]{2,}` +
            String.raw `|` +
            String.raw `(?:\d{1,3}\.){3}\d{1,3}` +
            String.raw `)` +
            String.raw `(?::\d{1,5})?` +
            String.raw `(?:\/[a-z\d%_.~+\-]*)*` +
            String.raw `(?:\?[;&a-z\d%_.~+=\-]*)?` +
            String.raw `(?:\#[a-z\d_-]*)?` +
            String.raw `$`, 'i');
        if (!pattern.test(s)) {
            return false;
        }
        if (/^(?:https?:\/\/)?(?:\d{1,3}\.){3}\d{1,3}/i.test(s)) {
            const host = s.replace(/^https?:\/\//i, '').split(/[/:?#]/)[0];
            const parts = host.split('.');
            return parts.every((p) => {
                const n = Number(p);
                return Number.isInteger(n) && n >= 0 && n <= 255;
            });
        }
        return true;
    }
    static openFixedURL(url) {
        if (!isValidString(url)) {
            return;
        }
        if (!url.startsWith('http')) {
            // #99499
            url = 'http://' + url;
        }
        return window.open(url);
    }
}
UrlUtils.urlRegex = /(https?:\/\/[^\s]+)/g;
